import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Col, Row, Form } from 'reactstrap';
import Cookies from 'js-cookie';
import { InputText } from "../inputs/text-input";
import Buttons from "../buttons/button-primary";
import InputEmail from "../inputs/email-input";
import InputPassword from "../inputs/password-input";
import validate from "./registrer-personal-validation";
import InputNumber from "../inputs/number-input";
import axios from 'axios';
import API from '../../API';
import ErrorText from '../../containers/addProject/error-msg';
//- Personal Form ==> Register Page 
const RgisterPersonal = (props) => {
    const registerPersonalLoading = useSelector(state => state.registerPersonal.loading);
    const registerPersonalError = useSelector(state => state.registerPersonal.error);
    const [state, setState] = useState({
        firstName: "",
        lastName:"",
        email: "",
        phone: "",
        password: "",
        confirmPassword: "",
        enableSMS:false,
        firstNameError: "",
        lastNameError: "",
        emailError: "",
        phoneError: "",
        passwordError: "",
        confirmPasswordError: "",
        referral_idError:"",
        referral_list: [],
        referral_id: [],
        valid: false
    });
    useEffect(() => {
        axios
        .get(API.baseURL + `/referral_list`, API.options)
        .then(response => response.data)
        .then(res => {
            if (res.code === 200) {
                setState({
                    referral_list: res.data
                });
            }
        });
    }, [])
    const handleCheckboxChange=(event) =>{
        setState((prevState) => ({
            ...prevState,
            enableSMS: event.target.checked
        }));
    }
    const handleInputChange = (event) => {
        setState((prevProps) => ({
            ...prevProps,
            [event.target.name]: event.target.value,
            firstNameError: "",
            lastNameError: "",
            emailError: "",
            phoneError: "",
            passwordError: "",
            confirmPasswordError: "",
            referral_idError: "",
        }));
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        const errors = validate(state);
        setState((prevProps) => ({
            ...prevProps,
            ...errors
        }));
        errors.valid && props.handleRegisterPersonal(state)
        errors.valid && Cookies.set("mobileNumber", state.phone)
    }
    // /sign_up

    return (
        <Form className="ebw-entry__register-form text-center" onSubmit={handleSubmit}>
            <Row form>
                <Col sm="12">
                    <InputText
                        label="First Name *"
                        name="firstName"
                        id="firstName"
                        value={state.firstName}
                        error={state.firstNameError}
                        changeEvent={handleInputChange}
                    />
                </Col>
                <Col sm="12">
                    <InputText
                        label="Last Name *"
                        name="lastName"
                        id="lastName"
                        value={state.lastName}
                        error={state.lastNameError}
                        changeEvent={handleInputChange}
                    />
                </Col>
                <Col sm="12">
                    <InputEmail
                        label="Email *"
                        name="email"
                        id="register_email"
                        value={state.email}
                        error={state.emailError}
                        changeEvent={handleInputChange}
                    />
                </Col>
                <Col sm="12">
                    <InputNumber
                        label="Phone *"
                        name="phone"
                        id="phone"
                        value={state.phone}
                        error={state.phoneError}
                        changeEvent={handleInputChange}
                    />
                </Col>
                <Col sm="12">
                    <InputPassword
                        label="Password *"
                        name="password"
                        id="register_password"
                        value={state.password}
                        error={state.passwordError}
                        changeEvent={handleInputChange}
                    />
                </Col>
                <Col sm="12">
                    <InputPassword
                        label="Confirm Password *"
                        name="confirmPassword"
                        id="register_password"
                        value={state.confirmPassword}
                        error={state.confirmPasswordError}
                        changeEvent={handleInputChange}
                    />
                </Col>
                <Col sm="12">
                    <div className="form-group">
                        <select
                            className="form-control custom-class ebw-form__input position-relative pl-3"
                            style={{height:52}}
                            name="referral_id"
                            // multiple={true}
                            value={state?.referral_id}
                            onChange={(e) => {
                            const selectedOptions = Array.from(e.target.selectedOptions, (option) => option.value);
                            setState((prevState) => ({
                                ...prevState,
                                referral_id: selectedOptions,
                                referral_idError: "",
                              }));
                            }}
                        >
                            <option value="">How did you hear about us? *</option>
                            {state?.referral_list?.map((data, i) => (
                            <option key={i} value={data.id}>{data.name}</option>
                            ))}
                        </select>
                        {state.referral_idError && <ErrorText>{state.referral_idError}</ErrorText>}
                    </div>
                </Col>
                <Col sm="12" className="mx-auto text-center">
                    <div className="form-group d-flex align-items-center">
                        <input
                            type="checkbox"
                            id="enableSMS"
                            checked={state.enableSMS}
                            onChange={(e) => handleCheckboxChange(e)}
                            style={{ fontSize: 12 }}
                        />
                        <label htmlFor="enableSMS" style={{ marginLeft: "8px",marginTop:10 }}>
                        I want to stay up to date with important updates via messages.
                        </label>
                    </div>
                </Col>
                <Col sm="12" className="mx-auto text-center">
                    {registerPersonalError ? <div className="ebw-error">{registerPersonalError}</div> : ""}
                </Col>

                <Col sm="12" md="12" xl="12" className="mx-auto text-center mt-4">
                    <Buttons
                        text="Submit"
                        disabled={registerPersonalLoading}
                    />
                </Col>
            </Row>
        </Form>
    );
}
export default RgisterPersonal;